document.addEventListener("DOMContentLoaded", (event) => {
  
  document.querySelectorAll('.product-collections-section').forEach((section) => {
    const tabs = section.querySelectorAll('.card-tabs .card-tab');
    const tabContents = section.querySelectorAll('.card-tab-cotent .card-tab-item');

    tabs.forEach((item) => {
        item.addEventListener('click', (e) => {
            let clickedTab = e.currentTarget;
            let cardTab = clickedTab.dataset.cardTab;

            // If the clicked tab is already active, do nothing
            if (clickedTab.classList.contains('active')) {
                return;
            }

            // Deactivate all tabs and contents within this section only
            tabs.forEach((cardItem) => cardItem.classList.remove('active'));
            tabContents.forEach((contentItem) => contentItem.classList.remove('active'));

            // Activate the clicked tab and its content
            clickedTab.classList.add('active');
            section.querySelector(`.card-tab-cotent .card-tab-item[data-card-tab="${cardTab}"]`)
                ?.classList.add('active');
        });
    });
});


  // Brand slider Js
  let brandSlider = document.querySelector('.brand-list-slider');
  if(brandSlider){
    var flkty = new Flickity( brandSlider, {
      wrapAround:true,
      imagesLoaded: true,
      cellAlign: 'center', 
      contain: true, 
      freeScroll: true, 
      autoPlay:true, 
      prevNextButtons: false, 
      pageDots: false 
    });  
  }

  // Testimonial slider Js
  let testimonial = document.querySelector('.testimonial-slider');
  if(testimonial){
    var flkty = new Flickity( testimonial, {
      wrapAround:true,
      cellAlign: 'left', 
      contain: true, 
      autoPlay:true, 
      prevNextButtons: false, 
      pageDots: true 
    });  
  }

  // Hero banner slider
  
  let heroBanner = document.querySelector('.hero-banner-slider');
  if(heroBanner){
    var flkty = new Flickity( heroBanner, {
      wrapAround:true,
      cellAlign: 'left',
      autoPlay:5000,
      contain: true, 
      prevNextButtons: false, 
      pageDots: true 
    });  
  }

});